var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{staticClass:"iFrameFormat",attrs:{"src":_vm.referralPageIFrameLinks,"title":"Refer a Friend"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }